import ZoomSwiper from "./index.vue"

export default ZoomSwiper